var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters_set)?_c('div',[_c('button',{staticClass:"button button--raw button--small",on:{"click":function($event){$event.preventDefault();return _vm.resetFilters($event)}}},[_vm._v("\n    Reset Filters\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }